import qs from "qs";
import { useState } from "react";
import { useLocation } from "react-router";
import { post } from "../../api";
import { CHANGE_NEWSLETTER_AGREEMENT, NEWSLETTER_AGREEMENT } from "../../api/apiRoutes";

export const NEWSLETTER_CONFIMRATION_SUCCESS = "NEWSLETTER_CONFIMRATION_SUCCESS";
export const NEWSLETTER_CONFIMRATION_WAITING = "NEWSLETTER_CONFIMRATION_WAITING";

/* eslint-disable import/no-anonymous-default-export */
export default () => {
  const [status, setStatus] = useState<string>(NEWSLETTER_CONFIMRATION_WAITING);
  const [alert, setAlert] = useState("");
  const location = useLocation();
  const facilityIds = qs.parse(location.search.slice(1)).facilityIds as string;
  const hash = qs.parse(location.search.slice(1), {
    decoder: (str, decoder, charset, type) => {
      if (type === "value" || type === "key") {
        return decodeURIComponent(str);
      }
      return str;
    },
  }).hash as string;

  // console.log("hash", hash);

  const onConfirm = async () => {
    const { isError } = await post(CHANGE_NEWSLETTER_AGREEMENT(facilityIds, hash));
    if (!isError) {
      setStatus(NEWSLETTER_CONFIMRATION_SUCCESS);
    }
  };

  const sendInvite = async (ids: string, email:string) => {
    const { isError } = await post(NEWSLETTER_AGREEMENT(ids, email));
    if (!isError) {
        setAlert("Dziękujemy. Za chwilę, na Twojej skrzynce pojawi się mail - wejdź i potwierdź zapis do newslettera.")
    }
  };

  return { alert, status, onConfirm, sendInvite };
};
